var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVhfset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-VHF_SET"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VHF_SET",
    "data-name": "VHF SET",
    clipPath: "url(#clip-VHF_SET)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "VHF_SET-2",
    "data-name": "VHF SET",
    transform: "translate(10 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 39,
    height: 27,
    transform: "translate(344.278 352.761)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 21,
    height: 15,
    transform: "translate(353.278 358.761)",
    fill: "#f30808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M318.566,155.89h140.7c19.417-.024,35.152-17.011,35.174-37.972V41.972C494.413,21.011,478.678,4.024,459.262,4h-140.7c-19.417.024-35.152,17.011-35.174,37.972V60.959H177.87c-38.834.047-70.3,34.021-70.348,75.945v56.959H72.348V4H37.174V193.862C17.757,193.886,2.022,210.873,2,231.835V459.669c.022,20.962,15.757,37.948,35.174,37.972H459.262c19.417-.024,35.152-17.011,35.174-37.972V231.835c-.022-20.962-15.757-37.948-35.174-37.972H142.7V136.9c.022-20.962,15.757-37.948,35.174-37.972H283.392v18.986c.022,20.962,15.757,37.948,35.174,37.972ZM388.914,41.972h70.348v75.945H388.914Zm-70.348,0H353.74v75.945H318.566Zm140.7,417.7H37.174V231.835H459.262Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 496,
    height: 500,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M9.148,24.18A3.09,3.09,0,1,1,12.3,21.09,3.119,3.119,0,0,1,9.148,24.18Zm0-4.635a1.545,1.545,0,1,0,1.574,1.545,1.56,1.56,0,0,0-1.574-1.545Z",
    transform: "translate(359.292 345.261)",
    fill: "#f6f1f1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 7,
    transform: "translate(355.5 366.5)",
    fill: "none",
    stroke: "#fefbfb",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVhfset);
export default __webpack_public_path__ + "static/media/VHF SET.034bfab1680728d4e92241f9b6cdd60d.svg";
export { ForwardRef as ReactComponent };